<script setup lang="ts">
// CTA Section Component
</script>

<template>
  <AppCTA
    title="Prêt à"
    titleHighlight="COMMENCER ?"
    subtitle="Les places sont limitées. N'attendez plus pour transformer votre passion en carrière."
    buttonText="Découvrir l'admission"
  />
</template>
